import _ from 'lodash';
import { JsonSchemaValidator } from "../../../Utils/JsonSchemaValidator";
// ---------------------------------------------------------------------------------------------------
export function MapInitializationJsonSchemeValidator() {
    return JsonSchemaValidator
        .GetInstance("MapInitializationJsonSchemeValidator", {
            title: "SelectDataType",
            type: "object",
            properties: {
                lat: { type: "number" },
                lng: { type: "number" },
                zoom: { type: "number" }
            },
            required: ["lat", "lng", "zoom"]
        });
}
// ------------------------------------------------------------------------------------------------------
export const selectFeaturesValidator = () => JsonSchemaValidator.GetInstance('selectFeaturesValidator', {
    type: 'object',
    properties: {
        featureIds: { type: ['number', 'string', 'array'] },
        openPopups: { type: ['number', 'string', 'array'] }
    }
});
// ------------------------------------------------------------------------------------------------------
export const settingsPanelsValidator = () => JsonSchemaValidator.GetInstance('settingsPanelsValidator', {
    type: 'array',
    items: {
        type: 'object',
        properties: {
            position: {
                type: 'string',
                enum: [
                    'topleft',
                    'topright',
                    'bottomleft',
                    'bottomright'
                ]
            },
            width: { type: 'number' },
            height: { type: 'number' },
            elements: {
                type: 'array',
                items: {
                    type: 'object',
                    properties: {
                        name: { type: 'string' },
                        elements: {
                            type: 'array',
                            items: {
                                type: 'object',
                                properties: {
                                    type: { type: ['number', 'string'] },
                                    label: { type: 'string' },
                                    dataPath: { type: 'string' }
                                }
                            }
                        }
                    }
                }
            },
            data: { type: 'object' },
            style: { type: 'object' }
        }
    }
});
// ------------------------------------------------------------------------------------------------
export function LeafletMapJsonSchemaValidator() {
    return JsonSchemaValidator.GetInstance("LeafletMapJsonSchemaValidator", {
        title: "LeafletMap",
        type: "object",
        properties: {
            // ------------------------------------------- +++ GeoJsonObject fields
            type: { enum: ["FeatureCollection"], },
            // number[]
            bbox: { type: "array", items: { type: ["number"] }, },
            // {type: string,properties:any}
            crs: { type: "object", properties: { type: { type: "string" }, properties: { type: "object" } } },
            // ------------------------------------------- --- GeoJsonObject fields
            // Array<Feature<G  extends GeometryObject, any>>
            features: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        // ------------------------------------------- +++ Feature<G, any> fields
                        type: { enum: ["Feature"] },
                        // DirectGeometryObject | GeometryCollection
                        geometry: {
                            type: "object",
                            properties: {
                                // ------------------------------------------- +++ common fields
                                // number[]
                                bbox: { type: "array", items: { type: ["number"] }, },
                                // {type: string,properties:any}
                                crs: { type: "object", properties: { type: { type: "string" }, properties: { type: "object" } } },
                                // ------------------------------------------- --- common fields
                                type: { enum: ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon", "GeometryCollection"] },
                                // number[] | number[][] | number[][][]
                                coordinates: { type: "array", items: { type: ["number", "array"] }, minItems: 1 },
                                // DirectGeometryObject[] | GeometryCollection[]
                                geometries: { type: "array", items: { type: "object" }, minItems: 1 }
                            },
                            required: ["type"]
                        },
                        properties: {
                            type: "object",
                            properties: {
                                radius: { type: "number" },
                                value: { type: ["number", "string"] },
                                marker: {
                                    type: "object",
                                    properties: {
                                        shape: {
                                            oneOf: [
                                                {
                                                    type: "null"
                                                },
                                                {
                                                    enum: ["square", "circle", "pin", "icon", "custom", "poly-circle"]
                                                }
                                            ]
                                        }
                                    }
                                },
                                openPopup: { type: 'boolean' },
                                imageOverlay: {
                                    type: 'object',
                                    properties: {
                                        url: { type: 'string' },
                                        angle: { type: 'number' }
                                    },
                                    required: ['url']
                                }
                            }
                        },
                        id: { type: ["string", "number"] },
                        isSelected: { type: "boolean" },
                        selectionStyle: {
                            type: 'object',
                            properties: {
                                outlineStyle: {
                                    type: 'string',
                                    enum: [
                                        'dotted',
                                        'dashed',
                                        'solid',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ]
                                },
                                outlineColor: { type: 'string' },
                                outlineWidth: { type: 'number' },
                                outlineOffset: { type: 'number' }
                            }
                        },
                        // ------------------------------------------- --- Feature<G, any> fields

                        // ------------------------------------------- +++ LeafletMapDataLayers
                        layers: {
                            type: "object",
                            patternProperties: {
                                "^.*$": {
                                    type: "object",
                                    properties: {
                                        tooltip: { type: "string" },
                                    },
                                }
                            }
                        }
                        // ------------------------------------------- --- LeafletMapDataLayers
                    },
                    required: ["type", "geometry"]
                }
            },
            fitBounds: { type: 'boolean' },
            center: {
                type: 'object',
                properties: {
                    lat: {
                        type: 'number',
                        minimum: -90,
                        maximum: 90
                    },
                    lng: {
                        type: 'number',
                        minimum: -180,
                        maximum: 180
                    },
                },
                required: ['lat', 'lng']
            },
            zoom: {
                type: 'number',
                minimum: 0,
                maximum: 20
            }
        },
        required: ["type", "features"]
    });
}